import * as React from 'react';
import { ORTHODONTIC_LKGCF_PATIENT_EXTENSION_SEARCH } from '../../utils/RouteConstants';
import { IOrthodonticLkgCfPatientExtensionSearchParams } from '../../models/IOrthodonticLkgCfPatientExtension';
import { Notification } from "./Notification";
import { IOrthodonticLkgCfPatientExtensionNotification } from '../../models/INotifications';

interface IOrthodonticLkgCfPatientExtensionNotifications {
    orthodonticLkgcfPatientExtensionAwaitingDecision?: IOrthodonticLkgCfPatientExtensionNotification;
}

export const OrthodonticLkgCfPatientExtensionNotifications: React.FunctionComponent<IOrthodonticLkgCfPatientExtensionNotifications> = ({ orthodonticLkgcfPatientExtensionAwaitingDecision }) => {

    const numberOfOrthodonticLkgcfPatientExtensionAwaitingDecisionSearchParams: IOrthodonticLkgCfPatientExtensionSearchParams = { orthodonticLkgCfPatientExtensionStatusId: orthodonticLkgcfPatientExtensionAwaitingDecision?.statusId, pageNumber: 1, pageSize: 10, propertyToOrderBy: "RegDate" };

    return (
        <>
            {
                orthodonticLkgcfPatientExtensionAwaitingDecision && orthodonticLkgcfPatientExtensionAwaitingDecision.amount > 0 ?
                    <Notification state={numberOfOrthodonticLkgcfPatientExtensionAwaitingDecisionSearchParams} amount={orthodonticLkgcfPatientExtensionAwaitingDecision.amount} linkText="Ansökningar om förlängning av LKG/CF" linkTo={`/${ORTHODONTIC_LKGCF_PATIENT_EXTENSION_SEARCH}`} />
                    : null
            }
        </>
    )
}